import DefaultVarchar from '../../defaultFields/varchar/varchar'

export default class Varchar extends DefaultVarchar {

}
